<template>
  <div
    v-if="show"
    class="popup--cart-upsell-wrapper"
  >
    <div class="popup popup--cart-upsell">
      <button
        class="popup__close close-btn xs font-semibold flex items-center"
        @click="closePopup"
      >
        Close
        <CloseIcon />
      </button>

      <h2
        class="popup__title h5 text-center"
        v-html="strings.general.title"
      />

      <div class="upsell-popup__selected flex">
        <div
          class="upsell-popup__selected-image cart-item__image"
          :class="{ 'cart-item__image--png': selectedUpsellProduct.image.includes('.png') }"
        >
          <img
            :src="selectedUpsellProduct.image"
            alt="free-gift-image"
            width="92"
            height="92"
          >
        </div>
        <div class="upsell-popup__selected-text">
          <h3 class="upsell-popup__selected-title">
            {{ selectedUpsellProduct.title }}
          </h3>
          <p class="upsell-popup__selected-price font-extrabold">
            {{ price }}
          </p>
        </div>
      </div>

      <v-select
        v-if="hasMoreThanOneAvailableProduct"
        v-model="selectedUpsellProduct"
        :options="products"
        :clearable="false"
        :searchable="false"
        class="free-gift-promo__dropdown upsell-popup__dropdown"
      >
        <template #selected-option="option">
          <div class="free-gift-promo__dropdown-selected flex items-center sm font-semibold capitalize">
            <div class="free-gift-promo__dropdown-image">
              <img
                :src="option.dropdownImage"
                width="30"
                height="30"
                class="w-full h-full object-contain"
              >
            </div>
            {{ option.title.toLowerCase() }}
            <ChevronRightIcon class="ml-auto" />
          </div>
        </template>

        <template #option="option">
          <div class="free-gift-promo__dropdown-item flex items-center xs capitalize">
            <div class="free-gift-promo__dropdown-image">
              <img
                :src="option.dropdownImage"
                width="30"
                height="30"
                class="w-full h-full object-contain"
              >
            </div>
            {{ option.title.toLowerCase() }}
          </div>
        </template>
      </v-select>

      <button
        class="upsell-popup__add-cta btn btn--black w-full"
        @click="addItemToCart"
      >
        Add to cart
      </button>
      <button
        class="cart-slideout__continue text-center mx-auto font-medium block sm underline"
        data-close
      >
        {{ strings.continue }}
      </button>
    </div>
  </div>
</template>

<script>
import CloseIcon from '../icons/close-icon'
import { productPrice } from '../helpers/product'

import { useCartStore } from '../pinia/CartStore'
import { mapState, mapActions } from 'pinia'

import ChevronRightIcon from '../icons/chevron-right'



export default {
  components: {
    CloseIcon,
    ChevronRightIcon,
  },
  props: {
  },
  data () {
    return {
      strings: { ...window.theme.cart.strings, ...window.theme.upsellPopups.strings },
      selectedUpsellProduct: [...window.theme.upsellPopups.general.collectionProducts].find(product => product.available),
      popupClosed: false
    }
  },
  computed: {
    ...mapState (useCartStore, [
      'items',
      'itemCount'
    ]),
    customerOptedOut () {
      return sessionStorage.getItem('cartUpsellClosed')
    },
    products () {
      const products = window.theme.upsellPopups.general.collectionProducts.filter(product => {
        return product.available && (!this.items.find(cartItem => cartItem.id === product.variants[0].id))
      })

      return products
    },
    hasAvailableProducts () {
      return this.products.length > 0
    },
    hasMoreThanOneAvailableProduct () {
      return this.products.length > 1
    },
    price () {
      return productPrice(this.selectedUpsellProduct.price)
    },
    payload () {
      return {
        items: [
          {
            id: this.selectedUpsellProduct.variants[0].id,
            quantity: 1
          }
        ]
      }
    },
    show () {
      return !this.customerOptedOut && this.hasAvailableProducts && !this.popupClosed && this.itemCount > 0
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(useCartStore, [
      'addItems'
    ]),
    closePopup () {
      sessionStorage.setItem("cartUpsellClosed", true)
      this.popupClosed = true
    },
    async addItemToCart () {
      await this.addItems(this.payload)
      sessionStorage.setItem("cartUpsellClosed", true)
      this.popupClosed = true
    },
  }
}
</script>
